/**
 * @description API Return Code 用
 */
export enum ReturnCode {
  /** 成功 */
  CodeSuccess='0000',

  /** 缺少必要參數 */
  CodeRequireParam = '1001',

  /** 參數格式錯誤 */
  CodeParamFormatError = '1002',

  /** 查無資料 */
  CodeNoInfo = '1003',

  /** 初始化參數錯誤 */
  CodeInitPrarmError = '1004',

  /** 資料已存在 */
  CodeExistData = '1005',

  /** 錯誤的參數 */
  CodeParamError = '1006',

  /** 保費計算錯誤 */
  CodeCalError = '1007',

  /** 登入 token 失效 */
  CodeNoAuth = '3019',
  /** 電話號碼或電子郵件地址不得與已註冊會員重複 */
  CodeMobileOrEmailRepeat = '3029',
  /** 投保作業-資料預覽頁，直接進入付款頁 */
  CodePassApplyNo = '3030',
  /** 系統連線異常 */
  CodeConnectionError = '2001',
  /** 行動裝置險-續保件未到期 */
  CodeMobileRenewalError = '3039',

  /** 中華電信航班查詢API連線異常 */
  CodeFightInfoConnectionError = '5301',
  /** 中華電信航班查詢API錯誤 */
  CodeFightInfoApiError = '5302',
  
  /** 投保任意險，廠型代號需輸入 */
  ModelCodeError = '2023',

  /** 系統發生未知錯誤 */
  CodeSystemError = '9999'
}
